import { ROUTES, SUPPORT_EMAIL } from '@shared/constants';
import { openPopUp as openPopUpAction } from '../../PopUp/actions';
import POPUP_TYPES from '../../PopUp/types';

export const renderSupportEmailBody = ({ t, bodyI18nKey, email }) => (
  <span>
    {t(bodyI18nKey)}{' '}
    <a
      href={`mailto:${email}`}
      style={{ textDecoration: 'underline', color: 'inherit' }}
    >
      {email}
    </a>
  </span>
);

export const getBackToSignInButtonText = (t) =>
  t('Authentication.Distribution.backToSignIn');

export const getSupportEmailPopupProps = ({
  t,
  titleI18nKey,
  bodyI18nKey,
  email = SUPPORT_EMAIL,
  onClose,
}) => ({
  titleText: t(titleI18nKey),
  bodyText: renderSupportEmailBody({ t, bodyI18nKey, email }),
  buttonText: getBackToSignInButtonText(t),
  onClose,
});

export const openSupportEmailPopupToSignIn = ({
  t,
  titleI18nKey,
  bodyI18nKey,
  history,
  email = SUPPORT_EMAIL,
  dispatch,
  openPopUp,
}) => {
  const onClose = () => {
    if (history?.push) {
      history.push(ROUTES.SIGN_IN);
    }
  };

  const props = getSupportEmailPopupProps({
    t,
    titleI18nKey,
    bodyI18nKey,
    email,
    onClose,
  });

  if (typeof openPopUp === 'function') {
    openPopUp(props);
    return;
  }

  if (typeof dispatch === 'function') {
    dispatch(openPopUpAction(POPUP_TYPES.ALERT, props));
  }
};
